import ComponentCategories from './ComponentCategories';

export default ComponentCategories;
